module.exports = __webpack_public_path__ + "img/证书@2x.51217638.png";